import { useLocation, useParams } from "react-router-dom";

export const useBuildingModelUid = () => {
    const { buildingModelUid } = useParams();
    const location = useLocation();

    if (!buildingModelUid) {
        const pathParts = location.pathname.split("/");

        if (pathParts[1] === "buildings" && pathParts[2]) {
            const buildingModelUid = pathParts[2];
            return buildingModelUid;
        }
        throw new Error("BuildingModelUid param needs to be defined");
    }

    return buildingModelUid;
};
